import { ReactElement } from "react";

export const MaintenanceIcon = (color?: string): ReactElement => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.0895 20.2316H5.10257C4.5733 20.2316 4.0657 20.0213 3.69144 19.6471C3.31719 19.2728 3.10693 18.7652 3.10693 18.236V6.26212C3.10693 5.73284 3.31719 5.22524 3.69144 4.85099C4.0657 4.47673 4.5733 4.26648 5.10257 4.26648H17.0764C17.6057 4.26648 18.1133 4.47673 18.4875 4.85099C18.8618 5.22524 19.0721 5.73284 19.0721 6.26212V11.2512"
        stroke={color ? color : '#000000'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.0808 2.27087V6.26215"
        stroke={color ? color : '#000000'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.0979 2.27087V6.26215"
        stroke={color ? color : '#000000'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.10693 10.2534H19.0721"
        stroke={color ? color : '#000000'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.0175 13.9894C16.1881 13.2868 17.1872 13.2868 17.3578 13.9894C17.468 14.4432 17.9879 14.6586 18.3868 14.4156C19.0042 14.0394 19.7107 14.7459 19.3345 15.3633C19.0915 15.7622 19.3069 16.2821 19.7607 16.3923C20.4633 16.5629 20.4633 17.5621 19.7607 17.7326C19.3069 17.8428 19.0915 18.3628 19.3345 18.7616C19.7107 19.379 19.0042 20.0855 18.3868 19.7093C17.9879 19.4663 17.468 19.6817 17.3578 20.1355C17.1872 20.8381 16.1881 20.8381 16.0175 20.1355C15.9073 19.6817 15.3873 19.4663 14.9885 19.7093C14.3711 20.0855 13.6646 19.379 14.0408 18.7616C14.2838 18.3628 14.0684 17.8428 13.6146 17.7326C12.912 17.5621 12.912 16.5629 13.6146 16.3923C14.0684 16.2821 14.2838 15.7622 14.0408 15.3633C13.6646 14.7459 14.3711 14.0394 14.9885 14.4156C15.3873 14.6586 15.9073 14.4432 16.0175 13.9894Z"
        stroke={color ? color : '#000000'}
        strokeWidth="0.9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.8876 17.0625C17.8876 17.7252 17.3504 18.2625 16.6876 18.2625C16.0249 18.2625 15.4876 17.7252 15.4876 17.0625C15.4876 16.3997 16.0249 15.8625 16.6876 15.8625C17.3504 15.8625 17.8876 16.3997 17.8876 17.0625Z"
        stroke={color ? color : '#000000'}
        strokeWidth="0.9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
